import { NavLink } from 'react-router';
import storeConnector from '@store/storeConnector';
import { SiteMeta } from '@src/types/SiteMeta';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';

function TopBar({ siteMeta }: { siteMeta: SiteMeta }) {
  return (
    <div className='topbar'>
      <div className='frame'>
        {siteMeta.ui.TabsList?.PV?.map((configuredTab) => (
          <NavLink
            data-test={`nav-sun-${configuredTab.toLowerCase()}`}
            key={`nav-sun-${configuredTab.toLowerCase()}`}
            to={`/sun/${configuredTab.toLowerCase()}`}
            className={({ isActive }) => `link ${isActive ? 'active' : ''}`}
          >
            <FormattedAlias id={configuredTab.toUpperCase()} />
          </NavLink>
        ))}
      </div>
    </div>
  );
}

export default storeConnector(TopBar, {
  config: ['siteMeta'],
});
